export default {
    keys: {
        id: 'id',
        expertises: 'expertises.name',
        tags: 'tags.id',
        country: 'country.name',
        partners: 'partners.title',
        status: 'status',
        services: 'service.id',
        date: 'dateItem.id'
    },
    operators: {
        in: 'In',
        lowerThan: 'Lt',
        greaterThan: 'Gt',
        notIn: 'NotEq'
    },
    inputTypes: {
        checkboxes: 'checkboxes',
        radio: 'radio',
        select: 'select',
        multiSelect: 'multiSelect',
        date: 'date',
        range: 'range',
        button: 'button'
    },
    queryParams: {
        page: 'page',
        text: 'text'
    },
    cookies: {
        mapView: 'mapView'
    },
    culture: {
        dutch: 'nl-NL',
        english: 'en-GB',
        american: 'en-US',
        french: 'fr-FR',
        arabic: 'ar-EG'
    },
    maps: {
        zoomLevels: {
            mobile: 8,
            tablet: 9,
            desktop: 10,
            widescreen: 11
        },
        breakpoints: {
            mobile: 768,
            tablet: 1024
        },
        coordinates: {
            utrecht: {
                lat: 52.0919,
                lng: 5.1230
            },
        },
    },
    project: {
        status: {
            ongoing: 'Ongoing',
            finished: 'Finished'
        }
    },
    card: {
        type: {
            news: 'news',
            project: 'project',
            partner: 'partner'
        }
    },
    magicStrings: {
        queryCount: '{{queryCount}}',
        totalCount: '{{totalCount}}'
    }
}